import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import Measure from "react-measure";
import ArrayUtil from "ArrayUtil";
import ExtremeDataValue from "ExtremeDataValue";
import FormatterUtil from "FormatterUtil";
import ThemeHelper from "ThemeHelper";
import Pointer from "Pointer";
import BlockType from "../../../../../Constants/BlockType.js";
import { LightDarkColorConstants } from "../../../../../Constants/LightDarkColorConstants.js";
import StringUtil from "../../../../../Utils/StringUtil.js";
import TrackPriceHelperFile from "../PriceChart/Helper/TrackPriceHelper.js";
import { updateShowToolTip } from "../../../../../Actions/DatagraphActions.js";
import { fetchTrackPriceAIData, setTriggerClose } from "../../../../../Actions/AINewsActions.js";
import TrackPriceAINews from "./TrackPriceAINews.jsx";
import GraphType from "../../../../../Constants/GraphType.js";

class TrackPrice extends Component {

    constructor(props) {
        super(props);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.removeTrackPrice = this.removeTrackPrice.bind(this);
        this.moveTrackPrice = this.moveTrackPrice.bind(this);
        this.onmouseleave = this.onmouseleave.bind(this);
        this.handleGlobalMouseDown = this.handleGlobalMouseDown.bind(this);
        this.getTrackPriceTemplate = this.getTrackPriceTemplate.bind(this);
        this.PriceChartView = {};
        this.holdTimer = null;
        this.lastPos = null;
        this.state = {
            dimensions: { width: 0.0 },
            topMargin: 25,
            crossHair: { x: -1, y: -1 },
            mousePosition: { x: -500, y: -500 },
            isMousedown: false,
            lastMove: Date.now(),
            template: null,
            dispTextR: " ",
            dispTextL: " ",
            ma1Value: " ",
            ma1PerChange: " ",
            ma1Color: " ",
            yma1: 0,
            ma2Value: " ",
            ma2PerChange: " ",
            ma2Color: " ",
            yma2: 0,
            previousNode: undefined,
            previousClient: null,
            isTopAlign: false,
            chart: null,
            pointers: [],
            lastValidPrice: 0,
            trackPriceDate: null,
            showAIPopup: false,
        };
        this.event = null;
        this.chart = null;
        this.trackPriceEvent = null;
    }

    componentDidMount() {
        if (this.props.externalInfoText) return;
        this.subscribe(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.externalInfoText) {
            this.unsubscribe(prevProps);
            this.removeTrackPrice();
            return;
        }
        if (Object.values(this.props.charts).length > 0) {
            this.unsubscribe(prevProps);
            this.subscribe(this.props);
        }
        if(this.event !== null && this.chart !== null && prevProps.HiLowPoints !== this.props.HiLowPoints){
            // on streaming
            this.invokeTrackPrice(this.event, this.chart, true)
        }
        // Check if isLoading or dimension changed
        if (
            (prevProps.isLoading !== this.props.isLoading || prevProps.dimension !== this.props.dimension || prevProps.triggerClose !== this.props.triggerClose) &&
            (this.props.isLoading || this.props.dimension || this.props.triggerClose) &&
            this.state.showAIPopup
        ) {
            this.removeTrackPrice(this.trackPriceEvent, true);
        }
    }
    componentWillUnmount() {
        this.unsubscribe(this.props);
        this.removeTrackPrice();
    }

    samePosition(x1, y1, pos) {
        if(!pos) {
            return false
        }
        const diffX = x1 - pos.x;
        const diffY = y1 - pos.y;

        return !(
            diffX >= this.props.nodeWidth ||
            diffX <= -this.props.nodeWidth ||
            diffY >= 1 ||
            diffY <= -1
        );
    }

    clearHoldTimer() {
        if (this.holdTimer) {
            clearTimeout(this.holdTimer);
            this.holdTimer = null;
        }
    }

    startHoldTimer(x, y) {
        // timeout for 2 sec and then open trackprice AI
        this.clearHoldTimer();
        this.holdTimer = setTimeout(() => {
            if (this.samePosition(x, y, this.lastPos)) {
                this.props.setTriggerClose(false);
                this.setState({ showAIPopup: true })
                this.invokeTrackPriceAI()
            }
        }, 2000);
    }

    handleGlobalMouseDown(e) {
        if (!(this.props.isTrackPriceAIApplicable)) {
            return;
        }
        const allCharts = Object.values(this.props.charts);
        const clickedElements = document.elementsFromPoint(e.clientX, e.clientY);

        // Check if any of your layer refs were clicked
        const hit = allCharts.find((el) =>
            clickedElements.includes(el.current?.chartContainer)
        );
        let isDisabled = this.checkDisableTrackPrice(e.target);
        const trackPriceAiNewsElement = document.getElementById("trackPriceAiNewsDiv");
        const reactionPopoverElement = document.getElementById("reaction-popover");
        if (
            trackPriceAiNewsElement &&
            (trackPriceAiNewsElement.contains(e.target)
                || (
                    reactionPopoverElement && reactionPopoverElement.contains(e.target)
                ))
        ) {
            return;
        }
        if (isDisabled === "true" || !hit) {
            this.removeTrackPrice(e, true);
        }
    };

    handleKeyDown = (e) => {
        if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
            this.removeTrackPrice(e, true)
        }
    };

    subscribe(props) {
        const allCharts = Object.values(props.charts);
        this.PriceChartView = props.charts[BlockType.Pricechart].current
        this.charts = allCharts;
        const length = allCharts.length;
        for (let i = 0; i < length; i++) {
            const view = allCharts[i].current;
            if (view) {
                const dom = ReactDOM.findDOMNode(view);
                dom.setAttribute("data-disable-track-price", false);
                dom.view = view;
                dom.addEventListener("mousedown", this.handleMouseDown, false);
                dom.addEventListener("mouseleave", this.onmouseleave, false);
                dom.addEventListener("mousemove", this.moveTrackPrice, false);
                dom.addEventListener("mouseup", this.removeTrackPrice, false);
            }
        }
        document.addEventListener("mousedown", this.handleGlobalMouseDown, false);
        document.addEventListener("keydown", this.handleKeyDown, false);
    }

    onmouseleave(e) {
        if (this.state.isMousedown) {
            this.removeAppendLayer(e.fromElement);
            const isDisabled = this.checkDisableTrackPrice(e.toElement);
            if (isDisabled !== "false") {
                //this.unsubscribe(this.props);
                this.removeTrackPrice(e, true);
            }
        }
    }

    checkDisableTrackPrice(element) {
        if (!element || !element.hasAttribute) {
            return "true";
        }
        else if (!element.hasAttribute("data-disable-track-price")) {
            const parentNode = element.parentNode;
            if (parentNode) {
                return this.checkDisableTrackPrice(parentNode);
            }
        }
        const result = element.getAttribute("data-disable-track-price");
        return result;
    }
    unsubscribe(props) {
        const allCharts = Object.values(props.charts);
        this.charts = [];
        const length = allCharts.length;
        for (let i = 0; i < length; i++) {
            const view = allCharts[i].current;

            if (view) {
                const dom = ReactDOM.findDOMNode(view);
                dom.removeEventListener("mousedown", this.handleMouseDown);
                dom.removeEventListener("mouseleave", this.onmouseleave, false);
                dom.removeEventListener("mousemove", this.moveTrackPrice);
                dom.removeEventListener("mouseup", this.removeTrackPrice);
            }

        }
        // checks for click outside pricechart to close trackprice AI
        document.removeEventListener("mousedown", this.handleGlobalMouseDown);
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    addLayerToChart(dom) {
        if (!this.layer && dom) {
            const layer = document.createElement('div');
            layer.className = 'track-price-layer';
            layer.id = 'trackPriceLayer';
            this.layer = layer;
            dom.appendChild(layer);
        }
    }

    removeAppendLayer(dom) {
        if (this.layer && dom && dom.contains(this.layer)) {
            try {
                dom.removeChild(this.layer);
                this.layer = undefined;
            }
            catch (e) {
                console.log('Error inside removeAppendLayer in TrackPrice.jsx', e)
            }
        }
    }
    handleMouseDown(e) {
        // Fix for PANWEB-6160 issue 1 - Avoid combined click events of trackprice and measurement annotation toggle grey box
        if (e.target.classList.contains("icn-collapser")) {
            return;
        }

        if (e.ctrlKey || e.metaKey) {
            this.removeTrackPrice(e, true);
            return;
        }

        if (e.which === 1) {
            const x = e.clientX;
            const y = e.clientY;
            this.lastPos = { x, y };

            if(this.state.showAIPopup) {
                this.setState({ showAIPopup: false })
            }
            this.startHoldTimer(x, y);
            
            const view = e.currentTarget.view;
            const isDisabled = this.checkDisableTrackPrice(e.target);
            if (isDisabled === "false") {
                //this.addLayerToChart(e.currentTarget);
                if (this.props.setCursor
                    && !(this.props.isTrackPriceAIApplicable)) {
                    this.props.setCursor("none");
                    this.props.updateShowToolTip(false)
                }

                setTimeout(() => {
                    this.invokeTrackPrice(e, view);
                }, 0);
            }
        }
        else {
            this.removeTrackPrice(e, true)
        }
    }

    handleResize(dimensions) {
        this.setState({ dimensions: dimensions });
    }

    invokeTrackPriceAI() {
        if (this.props.isTrackPriceAIApplicable && this.state.showAIPopup && this.state.previousNode && this.state.previousNode.node?.Date.getTime() <= this.props.endDate.getTime()) {
            const endDate = new Date(this.state.previousNode.date);
            this.props.fetchTrackPriceAIData(endDate, this.state.previousNode.trendType);
            this.setState({ trackPriceDate: endDate });
        }
    }

    invokeTrackPrice(e, chart, isStreaming = false) {
        if (!chart) {
            return;
        }
        let rect = chart.getBoundingClientRect();
        if (rect === undefined) {
            return;
        }
        const clientX = e.clientX - this.state.dimensions.left;
        const clientY = e.clientY - this.state.dimensions.top;
        const chartY = e.clientY - (rect.top);
        const marginTop = chart.trackpriceReqArgs.chartType === BlockType.Pricechart ? 15 : 0;
        let xAxis = clientX;
        if (xAxis < 0) {
            this.removeTrackPrice(e, true); // true- remove trackprice AI too
            return;
        }
        const dateNow = Date.now();
        const previousClient = {
            clientX: e.clientX,
            clientY: e.clientY
        };
        if (dateNow - this.state.lastMove > 20) {
            
            let mousedownvalue = true;
                if(this.props.isTrackPriceAIApplicable && isStreaming) {
                    mousedownvalue = false;
            }
            const diffx = clientX - this.state.crossHair.x;
            const diffy = clientY - this.state.crossHair.y;
            if (diffx >= this.props.nodeWidth || diffx <= -this.props.nodeWidth || diffy >= 1 || diffy <= -1 || this.event !== null) {
                let scale = [];
                this.trackPriceEvent = e;
                const nodeInfo = this.getTrackPriceTemplate(clientX, chart.trackpriceReqArgs, e, chart);
                scale = chart.props.scale;
                const value = this.props.dimension.width + this.state.dimensions.left >= e.clientX;
                const arrowPointers = [{ Key: "price" }];
                if (StringUtil.isEmpty(scale)) {
                    return;
                }
                const priceAtLocation = scale.ComputePrice(chartY - marginTop);
                if (!value && this.state.lastValidPrice === 0) {
                    this.setState({ lastValidPrice: priceAtLocation })
                }
                if (!nodeInfo && value) {
                    // Showing cross hair when nodedata is not available but one of the fundamental data lines are selected
                    this.setState({
                        pointers: arrowPointers,
                        rect,
                        chart,
                        dispTextR: " ",
                        dispTextL: chart.trackpriceReqArgs.chartType !== BlockType.Insider && ExtremeDataValue.showPrice(priceAtLocation),
                        crossHair: { x: clientX, y: clientY },
                        mousePosition: { x: e.clientX, y: e.clientY },
                        isMousedown: mousedownvalue,
                        lastMove: dateNow,
                        template: null,
                        previousNode: undefined,
                        previousClient: undefined,
                        contentHeight: rect.height,
                        lastValidPrice: 0
                    });
                    return;
                }
                else if (!value) {
                    return;
                }
                
                xAxis = nodeInfo.node ? nodeInfo.node.xAxis : nodeInfo.xAxis;
                let dispTextR = " ", dispTextL = " ";
                if(chart.trackpriceReqArgs.chartType === BlockType.Pricechart){
                    const changeInfo = nodeInfo.node ? (priceAtLocation - nodeInfo.node.graphData.Close) * 100 / nodeInfo.node.graphData.Close : 0;
                    const sign = changeInfo > 0 ? "+" : "";
                    dispTextL = ExtremeDataValue.showPrice(priceAtLocation);
                    dispTextR = `(${sign}${changeInfo.toFixed(0)}%)`;
                }
                else{
                    rect = this.PriceChartView.getBoundingClientRect();
                    if(chart.trackpriceReqArgs.chartType !== BlockType.Insider){
                        dispTextL = FormatterUtil.formatNumber(Math.round(priceAtLocation))
                    }
                }
                this.removeHighLightNode();
                if (nodeInfo.node.graphData.IsVisible) {
                    this.highLightNode(nodeInfo.nodeIndex);
                }
                this.setState({
                    rect,
                    chart,
                    dispTextR: nodeInfo?.pointers.length > 0 ? dispTextR : " ",
                    dispTextL,
                    pointers: nodeInfo?.pointers.length > 0 ? nodeInfo.pointers : arrowPointers,
                    crossHair: { x: xAxis, y: clientY },
                    mousePosition: { x: e.clientX, y: e.clientY },
                    isMousedown: mousedownvalue,
                    lastMove: dateNow,
                    template: nodeInfo.template,
                    previousNode: nodeInfo,
                    previousClient
                });
            }
        }
        setTimeout(() => {
            this.checkTopAlign();
        }, 0);
    }

    checkTopAlign() {
        if (this.content) {
            const rect = this.content.getBoundingClientRect();
            const limit = this.state.dimensions.bottom - this.state.dimensions.top;
            const isTopAlign = (this.state.crossHair.y + 15) + rect.height > limit;
            if (this.state.isTopAlign !== isTopAlign) {
                this.setState({ isTopAlign: isTopAlign, contentHeight: rect.height })
            }
        }
    }

    moveTrackPrice(e) {
        if (this.state.isMousedown && !(e.ctrlKey || e.metaKey)) {
            if (e && e.currentTarget) {
                this.addLayerToChart(e.currentTarget);
            }
            const view = e.currentTarget.view;
            this.invokeTrackPrice(e, view);
            e.preventDefault();
            e.stopPropagation();
            if(this.props.isTrackPriceAIApplicable && this.state.previousNode?.node?.Date.getTime() <= this.props.endDate.getTime()) {
                this.setState({ showAIPopup: false })
                this.clearHoldTimer();
                const x = e.clientX;
                const y = e.clientY;
                this.lastPos = { x, y };

                this.startHoldTimer(x, y);
            }
        }
    }

    removeTrackPrice(e, removeTrackPriceAINews) {
        if (!e) {
            return;
        }
        this.lastPos = null;
        let target;
        if (e && e.currentTarget) {
            target = e.currentTarget;
        }

        if (this.props.isTrackPriceAIApplicable
            && !removeTrackPriceAINews && this.state.template && this.state.previousNode.node?.Date.getTime() <= this.props.endDate.getTime() && !(e.ctrlKey || e.metaKey) ) {
            const x = e.clientX;
            const y = e.clientY;
            this.clearHoldTimer();
            if(target) {
                this.removeAppendLayer(target);
            }
            if(!this.state.showAIPopup || (this.state.isMousedown && !this.samePosition(x, y, this.state.mousePosition))) {
                this.trackPriceEvent = e;            
                this.props.setTriggerClose(false);  
                this.setState({ showAIPopup: true });
                this.invokeTrackPriceAI()
            }
            this.setState({ isMousedown: false })
            return;
        }

        setTimeout(() => {
            if (target) {
                this.removeAppendLayer(target)
            }
            this.event = null;
            this.chart = null;
            this.trackPriceEvent = null;
            this.setState({ pointers: [] ,crossHair: { x: -1, y: -1 }, mousePosition: { x: -500, y: -500 }, isMousedown: false, lastMove: Date.now(), template: null, isTopAlign: false });
            this.removeHighLightNode();

            if (this.props.setCursor) {
                this.props.setCursor("auto");
                this.props.updateShowToolTip(true)
            }
        }, 0);

    }

    removeHighLightNode() {
        const node = this.state.previousNode;
        if (node) {
            const charts = this.charts;
            const length = charts.length;
            for (let i = 0; i < length; i++) {
                const chart = charts[i];
                if (chart?.current?.trackpriceReqArgs?.barVisual?.current) {
                    chart.current.trackpriceReqArgs.barVisual.current.removeHighLightedNode(node.nodeIndex);
                }
            }
        }
    }
    highLightNode(nodeIndex) {
        const charts = this.charts;
        const length = charts.length;
        for (let i = 0; i < length; i++) {
            const chart = charts[i];
            if (chart?.current?.trackpriceReqArgs?.barVisual?.current) {
                chart.current.trackpriceReqArgs.barVisual.current.highLightNode(nodeIndex);
            }
        }
    }
    handleUpdatePrice(e, nodeInfo) {
        const clientX = e.clientX - this.state.dimensions.left;
        const clientY = e.clientY - this.state.dimensions.top;
        let xAxis = clientX;
        let template = null;
        if (nodeInfo !== null && nodeInfo) {
            template = nodeInfo.template;
            xAxis = nodeInfo.node.xAxis;
        }
        const dateNow = Date.now();
        this.setState({
            pointers: nodeInfo.pointers,
            crossHair: { x: xAxis, y: clientY },
            mousePosition: { x: e.clientX, y: e.clientY },
            isMousedown: true,
            lastMove: dateNow,
            template: template,
            previousNode: nodeInfo
        });
    }
    getPointer() {
        const pointers = [];
        const textColor = "#000";//ThemeHelper.getThemedBrush("fff000");
        const noText = this.state.dispTextL === " " && this.state.dispTextR === " ";

        if (this.state.isMousedown && this.state.pointers && !noText) {
            const ptLen = this.state.pointers.length;
            for (let ptNum = 0; ptNum < ptLen; ptNum++) {
                const pt = this.state.pointers[ptNum];
                if (pt === undefined || pt === null) {
                    return pointers;
                }
                const key = pt.Key;
                if (!this.state.rect) {
                    return pointers;
                }
                const rect = this.state.rect;
                const yAxis = pt.yAxis + rect.top - 75;
                switch (key) {
                    case "tech":
                    case "price":
                    case "volume":
                        pointers.push(<Pointer key={key}
                            contentR={this.state.dispTextR}
                            contentL={this.state.dispTextL}
                            x={this.state.dimensions.width - 157} y={this.state.crossHair.y - 10} height={20} width={115} stroke="black"
                            fill={"#cccccc"} lcolor={textColor} rcolor={textColor} />);
                        break;
                    case "closePrice":
                        pointers.push(<Pointer key={key}
                            contentR={pt.dispTextR}
                            contentL={pt.dispTextL}
                            x={this.state.dimensions.width - 157} y={yAxis} height={20} width={115} stroke="black"
                            fill={"#cccccc"} lcolor="black" rcolor="black" />);
                        break;
                    default:
                        if (key.indexOf('maLine') !== -1) {
                            const lineColor = ThemeHelper.getThemedBrush(pt.Color);
                            const lineFontColor = ArrayUtil.contains(LightDarkColorConstants.LightColor, lineColor) ? "black" : "white";
                            pointers.push(<Pointer key={key}
                                contentR={pt.dispTextR}
                                contentL={pt.dispTextL}
                                x={this.state.dimensions.width - 157} y={yAxis} height={20} width={115} stroke="black"
                                fill={lineColor} lcolor={lineFontColor} rcolor={lineFontColor} />);
                        }
                        break;
                }
            }
        }
        return pointers;
    }

    getCrossHairs() {
        if (this.state.dimensions.height) {
            return `M 0 ${this.state.crossHair.y.toFixed(0)} L ${(this.state.crossHair.x - 7).toFixed(0)} ${this.state.crossHair.y.toFixed(0)} 
            M ${(this.state.crossHair.x - 3).toFixed(0)} ${this.state.crossHair.y.toFixed(0)} L ${(this.state.crossHair.x + 4).toFixed(0)} ${this.state.crossHair.y.toFixed(0)} 
            M ${(this.state.crossHair.x + 8).toFixed(0)} ${this.state.crossHair.y.toFixed(0)} L ${(this.state.dimensions.width - (this.props.rightScaleWidth + this.props.leftScaleWidth)).toFixed(0)} ${this.state.crossHair.y.toFixed(0)} 
            M ${this.state.crossHair.x} ${(this.state.topMargin + 2).toFixed(0)} L ${this.state.crossHair.x} ${(this.state.crossHair.y - 7).toFixed(0)} 
            M ${this.state.crossHair.x} ${(this.state.crossHair.y - 3).toFixed(0)} L ${this.state.crossHair.x} ${(this.state.crossHair.y + 4).toFixed(0)} 
            M ${this.state.crossHair.x} ${(this.state.crossHair.y + 8).toFixed(0)} L ${this.state.crossHair.x} ${(this.state.dimensions.height - 18)} `;
        } else {
            return " ";
        }
    }
    getTrackPriceTemplate = (clientX, trackpriceReqArgs, event, chart) => {
        const padding = this.props.padding * this.props.nodeWidth;
        const posFromRight = this.props.chartWidth - padding - clientX;
        const nodeIndex = Math.floor(posFromRight / this.props.nodeWidth);
        this.event = event;
        this.chart = chart;
        const nodeData = TrackPriceHelperFile.getPriceChartTrackPriceNodeData(nodeIndex, trackpriceReqArgs);
        if (!nodeData) {
            return nodeData;
        }
        nodeData.template = TrackPriceHelperFile.getTrackPriceTemplate(nodeData, this.props.isVolumeOpen, trackpriceReqArgs);
        return nodeData;
    }

    render() {
        const style = { strokeWidth: "1", shapeRendering: "crispEdges" };
        let isleftAlign = this.state.crossHair.x - 194 > 0;
        if (this.props.isTrackPriceAIApplicable) {
            isleftAlign = this.state.crossHair.x - 400 > 0;
        }
        const pointers = this.getPointer();
        const crossHairPath = this.getCrossHairs()
        //  var hairColor = ThemeHelper.getThemedBrush("fff666");
        return (
            <Measure
                bounds
                onResize={(contentRect) => {
                    this.handleResize(contentRect.bounds)
                }}
            >
                {({ measureRef }) =>
                    <div ref={measureRef} id="TrackPrice" className="trackPrice" style={{
                        marginLeft: `${this.props.leftScaleWidth}px`,
                        marginRight: `${this.props.rightScaleWidth}px`,
                        top: "0px",
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        left: "0",
                        zIndex: "1060"
                    }}>
                        <div className="crossHair" style={{ zIndex: "1060", left: 0, width: "100%", height: "100%", top: "0", position: "absolute" }}>
                            <div ref={(ref) => (this.content = ref)} className="content cross-hair-tooltip" style={{
                                position: "absolute",
                                left: isleftAlign ? this.state.crossHair.x - 194 : this.state.crossHair.x + 14,
                                top: this.state.isTopAlign ? this.state.crossHair.y - (this.state.contentHeight + 15) : this.state.crossHair.y + 15
                            }}>
                                {this.state.template}
                            </div>
                            { this.props.isTrackPriceAIApplicable
                                && this.state.template && this.state.showAIPopup &&
                                this.state.previousNode?.node?.Date.getTime() <= this.props.endDate.getTime() &&
                                <TrackPriceAINews
                                    mousePosition={this.state.mousePosition}
                                    screenWidth={window.innerWidth}
                                    screenHeight={window.innerHeight}
                                    refBlockHeight={this.state.contentHeight}
                                    isTopAlign={this.state.isTopAlign}
                                    isLeftAlign={isleftAlign}
                                    show={this.props.isTrackPriceAIApplicable}
                                    hidePopup={(e) => this.removeTrackPrice(e, true)}
                                    trackPriceAINews={this.props.trackPriceAINews}
                                    trackPriceRef={this.content}
                                    trackPriceDate={this.state.trackPriceDate}
                                />
                            }
                            {pointers}
                        </div>

                        <svg ref={(ref) => (this.svg = ref)}
                            style={{ position: "absolute", width: "100%", height: this.state.dimensions.height, top: "0px", left: "0" }}>
                            <path d={crossHairPath} style={style} stroke="#999999" className="crossHair" />
                        </svg>
                    </div>
                }
            </Measure>
        );
    }
}

const mapStateToProps = ({ DatagraphReducers, externalDataUploader, aiNewsReducer, RelatedInfoPanelReducers }) => {
    const { charts, chartWidth, HiLowPoints, dimension } = DatagraphReducers.PriceChartReducer;
    const { isVolumeOpen } = DatagraphReducers.volumeChartReducer;
    const { padding, nodeWidth, leftScaleWidth, rightScaleWidth, majorPeriodicity, SymTypeEnum, isLoading, endDate } = DatagraphReducers.DataGraphReducer;
    const { selectedPerShare } = DatagraphReducers.FundamentalLineReducer;
    const { externalInfoText } = externalDataUploader.externalDataUploadSymbolReducer
    const { trackPriceAINews, applicableInstrumentsTrackPriceAI, triggerClose } = aiNewsReducer;
    const { isTrackPriceAIVisible } = RelatedInfoPanelReducers.RiPanelAI;
    const isTrackPriceAIApplicableForSymbol = applicableInstrumentsTrackPriceAI.includes(SymTypeEnum) ? true : false;
    const isTrackPriceAIApplicableForPeriodicity = majorPeriodicity === GraphType.Daily || majorPeriodicity === GraphType.Weekly || majorPeriodicity === GraphType.Monthly
    const isTrackPriceAIApplicable = isTrackPriceAIVisible && isTrackPriceAIApplicableForPeriodicity && isTrackPriceAIApplicableForSymbol

    return { charts, chartWidth, padding, isVolumeOpen, nodeWidth, leftScaleWidth, rightScaleWidth, HiLowPoints, selectedPerShare, dimension, isLoading, externalInfoText, trackPriceAINews, isTrackPriceAIApplicable, triggerClose, endDate }
}

const mapDispatchToProps = (dispatch)=>({
    updateShowToolTip: (showTootTip)=> dispatch(updateShowToolTip(showTootTip)),
    fetchTrackPriceAIData: (endDate, trendType)=> dispatch(fetchTrackPriceAIData(endDate, trendType)),
    setTriggerClose: (triggerClose) => dispatch(setTriggerClose(triggerClose)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TrackPrice)